import { render, staticRenderFns } from "./BackgroundFader.vue?vue&type=template&id=b3a3a43e&scoped=true&"
import script from "./BackgroundFader.vue?vue&type=script&lang=js&"
export * from "./BackgroundFader.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundFader.vue?vue&type=style&index=0&id=b3a3a43e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a3a43e",
  null
  
)

component.options.__file = "BackgroundFader.vue"
export default component.exports